function setRecommendationFormLoading(form, isLoading) {
  const button = form.querySelector('[type="submit"]');
  const spinner = form.querySelector('.loading__spinner');
  if (!button) return;

  button.classList.toggle('loading', isLoading);
  button.toggleAttribute('aria-disabled', isLoading);
  button.disabled = isLoading;
  spinner?.classList.toggle('hidden', !isLoading);
}

function getNelkoRecommendationSwatch(target) {
  return target instanceof Element ? target.closest('[data-nelko-recommendation-swatch]') : null;
}

function updateNelkoRecommendationCardBySwatch(swatch) {
  if (swatch.getAttribute('aria-disabled') === 'true') return;

  const card = swatch.closest('[data-nelko-recommendation-card]');
  if (!card) return;

  const variantInput = card.querySelector('[data-nelko-recommendation-variant-id]');
  const priceEl = card.querySelector('[data-nelko-recommendation-price]');
  const comparePriceEl = card.querySelector('[data-nelko-recommendation-compare-price]');
  const submitBtn = card.querySelector('.nelko-recommendation-card__submit');
  const submitLabel = submitBtn?.querySelector('span');
  const image = card.querySelector('.nelko-recommendation-card__image img');
  const imageSrc = swatch.dataset.imageSrc;

  card.querySelectorAll('[data-nelko-recommendation-swatch]').forEach((element) => {
    const isActive = element === swatch;
    element.classList.toggle('is-active', isActive);
    element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  if (variantInput && swatch.dataset.variantId) {
    variantInput.value = swatch.dataset.variantId;
  }

  if (priceEl && swatch.dataset.price) {
    priceEl.textContent = swatch.dataset.price;
  }

  if (comparePriceEl) {
    const comparePrice = swatch.dataset.comparePrice || '';
    comparePriceEl.textContent = comparePrice;
    comparePriceEl.hidden = !comparePrice;
  }

  if (image && imageSrc) {
    if (swatch.dataset.imageSrcset) {
      image.srcset = swatch.dataset.imageSrcset;
    } else {
      image.removeAttribute('srcset');
    }
    image.src = imageSrc;
    if (swatch.dataset.imageAlt) {
      image.alt = swatch.dataset.imageAlt;
    }
  }

  const isAvailable = swatch.dataset.variantAvailable === 'true';
  if (submitBtn) {
    submitBtn.disabled = !isAvailable;
    if (submitLabel) {
      submitLabel.textContent = isAvailable ? 'Add To Bag' : 'Sold Out';
    }
  }
}

function handleNelkoRecommendationSwatchInteraction(event) {
  const swatch = getNelkoRecommendationSwatch(event.target);
  if (!swatch) return;

  if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;

  event.preventDefault();
  event.stopPropagation();
  updateNelkoRecommendationCardBySwatch(swatch);
}

function initNelkoRecommendationCards(root = document) {
  root.querySelectorAll('[data-nelko-recommendation-card]').forEach((card) => {
    const activeSwatch = card.querySelector('[data-nelko-recommendation-swatch].is-active');
    if (activeSwatch) {
      updateNelkoRecommendationCardBySwatch(activeSwatch);
    }
  });
}

async function loadNelkoRecommendations() {
  const section = document.querySelector('[data-nelko-recommendations-url], [data-recommendations-url]');
  if (!section) return;

  const recommendationsUrl = section.dataset.nelkoRecommendationsUrl || section.dataset.recommendationsUrl;
  if (!recommendationsUrl.includes('product_id=')) return;

  const response = await fetch(recommendationsUrl);
  if (!response.ok) return;

  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const content = parsed.querySelector('[data-recommendations-content]');
  if (content?.children.length) {
    section.querySelector('[data-recommendations-content]').replaceChildren(...content.children);
    initNelkoRecommendationCards(section);
  }
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-nelko-recommendation-form]');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('[type="submit"]');
  if (button?.getAttribute('aria-disabled') === 'true') return;

  setRecommendationFormLoading(form, true);

  const root = window.Shopify?.routes?.root || '/';

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new FormData(form),
    });

    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || 'Unable to add item to cart.');
    }

    document.dispatchEvent(
      new CustomEvent('nelko:cart-added', {
        detail: {
          cartData: data,
          productVariantId: data.id,
        },
      })
    );

    if (typeof updateNelkoCartCount === 'function') {
      updateNelkoCartCount();
    }

    window.location.reload();
  } catch (error) {
    setRecommendationFormLoading(form, false);
    console.error(error);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  loadNelkoRecommendations();
  initNelkoRecommendationCards();
});
document.addEventListener('nelko:recommendations-loaded', (event) => {
  initNelkoRecommendationCards(event.detail?.element || document);
});
document.addEventListener('click', handleNelkoRecommendationSwatchInteraction);
document.addEventListener('keydown', handleNelkoRecommendationSwatchInteraction);
